import { render } from "./green-home.vue?vue&type=template&id=0d46a2c3&scoped=true"
import script from "./green-home.vue?vue&type=script&lang=js"
export * from "./green-home.vue?vue&type=script&lang=js"

import "./green-home.vue?vue&type=style&index=0&id=0d46a2c3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d46a2c3"

export default script